import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withDetailedIcon } from '../DetailedIcon';
var innerSvg = '<path class="DetailedIcon__secondary-color-fill" d="M34.1,17.2,20.645,4.533a2.667,2.667,0,0,0-3.2,0L3.993,17.2a2.668,2.668,0,0,0-.948,2.039V39.333A2.667,2.667,0,0,0,5.711,42H32.378a2.667,2.667,0,0,0,2.667-2.667V19.24A2.666,2.666,0,0,0,34.1,17.2ZM24.378,39.333H13.711V28.667A2.667,2.667,0,0,1,16.378,26h5.333a2.667,2.667,0,0,1,2.667,2.667Z"/><rect class="DetailedIcon__accent-color-fill" x="22.365" y="25.37" width="5.05" height="10.1"/><path class="DetailedIcon__foreground-color-fill" d="M39.145,14.51,26.4,2.51a2.5,2.5,0,0,0-3.029,0l-12.75,12a2.515,2.515,0,0,0-.9,1.93V35.47A2.533,2.533,0,0,0,12.255,38h25.26a2.527,2.527,0,0,0,2.53-2.53V16.44A2.515,2.515,0,0,0,39.145,14.51ZM27.415,35.47h-5.05V25.37h5.05Zm10.1,0h-7.58V25.37a2.524,2.524,0,0,0-2.52-2.53h-5.05a2.527,2.527,0,0,0-2.53,2.53v10.1h-7.58V16.44l.05-.05.05-.04,12.53-11.8,12.53,11.8.05.04.05.05Z"/>';
export var HomeSVG = function HomeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
HomeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withDetailedIcon(HomeSVG);